<template>
  <PageVC :has-newsletter-form="order && entered" class="table-receipt">
    <div class="a-container">
      <HUILoadingView v-if="!order || !entered" />
      <template v-else-if="order.status === OrderStatus.CLOSED">
        <h1 class="a-page-title">Mange tak &ndash; din betaling er modtaget</h1>
        <p
          class="a-page-subtitle"
        >Du må meget gerne vise beskeden her til en tjener, inden du forlader restauranten.</p>
        <div class="a-rich-text a-rich-text--centered">
          <img
            src="https://halifax.dk/images/frontend/desktop/illustrations/heart@2x.png"
            height="120"
          />
          <p class="table-receipt__thanks">
            <em>
              Vi håber, du har nydt
              <br />dit besøg hos os i dag!
            </em>
          </p>
        </div>
        <form class="table-receipt__rating-form" @submit.prevent="handleSubmit">
          <template v-if="ratingToken === null || ratingToken && ratingCommentSubmitted">
            <h2 class="table-receipt__rating-heading">
              <template v-if="ratingToken === null">Har du lyst til at bedømme os?</template>
              <template v-else>Tusind tak for din bedømmelse!</template>
              <transition name="t-fade">
                <HUILoadingView class="table-receipt__rating-loader" absolute v-if="submitting" />
              </transition>
            </h2>
            <HUIRating :disabled="rating > 0" v-model.number="rating" :value="rating" />
          </template>
          <template v-else-if="!ratingCommentSubmitted">
            <h2 class="table-receipt__rating-heading">Tak. Vil du begrunde dit valg?</h2>
            <div class="table-receipt__button-group a-button-group">
              <HUITextInput
                class
                required
                :disabled="submitting"
                type="text"
                placeholder="Kommentar"
                name="rating_comment"
                v-model="ratingComment"
              />
              <HUIButton
                class
                :spinner="submitting"
                :disabled="ratingComment.length === 0"
                type="submit"
                theme="green"
              >Send</HUIButton>
            </div>
          </template>
        </form>
      </template>
    </div>
  </PageVC>
</template>

<script>
import { HUILoadingView, HUIButton, HUIRating, HUITextInput } from '@/halifax-ui'
import TableBase from '@/views/TableBase'
import PageVC from '@/containers/PageVC'
import { ApiHttpError } from '@/api'
import { OrderStatus } from '@/store/order'

export default {
  extends: TableBase,
  components: {
    PageVC,
    HUILoadingView,
    HUIButton,
    HUITextInput,
    HUIRating
  },
  data() {
    return {
      rating: 0,
      ratingComment: '',
      submitting: false,
      ratingCommentSubmitted: false,
      ratingToken: null,
      OrderStatus
    }
  },
  watch: {
    async rating(value) {
      // Rating only changes once, because we disable if rating is larger than 0
      setTimeout(this.submitRating, 500)
    }
  },
  methods: {
    async submitRating() {
      this.submitting = true
      this.ratingToken = await this.$store.dispatch('order/CREATE_RATING', {
        orderToken: this.orderToken,
        rating: this.rating
      })
      this.submitting = false
    },
    async handleSubmit() {
      this.submitting = true
      await this.$store.dispatch('order/CREATE_RATING_COMMENT', {
        ratingToken: this.ratingToken,
        rating: this.rating,
        comment: this.ratingComment
      })
      this.ratingCommentSubmitted = true
      this.submitting = false
    }
  }
}
</script>

<style lang="scss">
@import '~@/scss/variables';
@import '~@/halifax-ui/src/scss/framework';

.table-receipt {
  $module: '.table-receipt';

  &__rating-form {
    text-align: center;
    margin-top: 40px;

    .hui-rating {
      padding-bottom: 10px;
      margin-top: -10px;
    }
  }
  &__button-group {
    .hui-text-input {
      width: 100%;
    }
    .hui-button {
      width: auto;
    }
  }
  &__rating-heading {
    position: relative;
    margin-bottom: 15px;
  }
  &__rating-loader {
    background: rgba($background-color, 0.9);
    transform: translateY(0px);
  }
  &__thanks {
    color: darken(desaturate($background-color, 30%), 25%);
  }
}
</style>
